<app-header>  </app-header>
<main>


<div class="banner-wrapper">
  <img src="assets/background.png" alt="Profile" class="wide-banner" />

<!--
<div class="banner-wrapper">
  <div id="banner" class="wide-banner">
    <h1>{{ 'home.banner' | translate}}</h1> contiene la scritta nel banner tradotta
  </div>
-->

<div class="filters">

  <mat-icon>filter_list</mat-icon>
  <!-- COUNTRY -->
  <mat-form-field appearance="outline" floatLabel="always">

    <mat-label>{{ 'home.country.select.title' | translate}}</mat-label>
    <mat-select placeholder="{{ 'home.country.placeholder' | translate}}" [(ngModel)]="selectedCountry" (selectionChange)="onCountryChange()">

      <mat-option>{{ "home.country.select.default" | translate}}</mat-option>
      @for(country of countries;track country.id) {
      <mat-option [value]="country.name">{{ country.name }}</mat-option>
      } 

    </mat-select>

  </mat-form-field>

<!-- CITY -->
  <mat-form-field appearance="outline" floatLabel="always" [class.disabled]="!selectedCountry">

    <mat-label>{{ 'home.city.select.title' | translate}}</mat-label>
    <mat-select placeholder="{{ 'home.city.placeholder' | translate}}" [(ngModel)]="selectedCities" (selectionChange)="onCitiesChange()" [disabled]="!selectedCountry" multiple>
      <mat-select-trigger>
        @if (selectedCities.includes('')) {
          {{ 'common.allCities' | translate }}
        } @else {
          {{selectedCities[0] || ''}}
          @if ((selectedCities.length || 0) > 1) {
            <span class="additional-selection">
              (+{{(selectedCities.length || 0) - 1}} {{ selectedCities.length === 2 ? ('common.other' | translate) : ('common.others' | translate) }})
            </span>
          }
        }
      </mat-select-trigger>
      <mat-option value="">{{ "home.city.select.default" | translate}}</mat-option>
      @for(city of filteredCities;track city.id) {
      <mat-option [value]="city.name">
        {{ city.name }}
      </mat-option>
      } 

    </mat-select>

  </mat-form-field>


<!-- SECTOR -->
  <mat-form-field appearance="outline" floatLabel="always">

    <mat-label>{{ "home.sector.select.title" | translate}}</mat-label>
    <mat-select placeholder="{{ 'home.sector.placeholder' | translate}}" [(ngModel)]="selectedSector" (selectionChange)=applyFilters()>

      <mat-option>{{ "home.sector.select.default" | translate}}</mat-option>
      @for(sector of sectors;track sector) {
      <mat-option [value]="sector">{{ sector.name }}</mat-option>
      } 

    </mat-select>

  </mat-form-field>

  <!-- BADGE FILTER -->
  <div class="badge-toggle" [class.active]="badgeFilter" (click)="badgeCheckFilter()">
    <mat-icon>workspace_premium</mat-icon>
    <span>{{ 'home.badge' | translate }}</span>
  </div>

  <!-- SEARCH -->
  <!--<button class="search-btn" (click)="applyFilters()"><mat-icon>search</mat-icon></button>-->

</div>


  
<div class="filterss">
<input
  type="text"
  name="company"
  class="country-input"
  placeholder= '{{ "home.search" | translate }}'
  [(ngModel)]="searchTerm"
  (input)="applyFilters()"  
/>
<mat-icon>search</mat-icon>
</div>


</div>


<div class="recent-companies">

<div class="recent-header">

  <h2>{{ "home.recently.created" | translate}}</h2>
  <a class="view-all" (click)="goToAllCompanies()">{{ "home.viewall" | translate }}</a>

</div>
  
<div class="companies-container">
  @for(company of filteredCompanies; track company.id){
  <div class="company-card" (click)="openCompanyModal(company)">
    <div class="card-top">
      <div class="logo-container" *ngIf="company.logoBase64">
        <img
          [src]="'data:image/png;base64,' + company.logoBase64"
          alt="{{ company.name }} logo"
          class="company-logo"
        />
      </div>
      <div class="card-info">
        @if (company.badge) {
            <h3>{{ company.name }} <mat-icon [matTooltip]="'common.badgeVerified' | translate" matTooltipPosition="above" class="icon-badge">workspace_premium</mat-icon></h3>
        }
        @else {
            <h3>{{ company.name }}</h3>
        }
        <p>{{ company.country?.name || company.city?.country?.name || 'N/A' }}, {{ company.city?.name || 'N/A' }}</p>
        <div class="rating">
          ⭐ <span>{{ company.inclusionIndex != null ? company.inclusionIndex.toFixed(2) : 'N/A' }}</span>
        </div>
      </div>
    </div>

    <div class="card-bottom">
     <div class="trainee-count">
  👨‍🎓 {{ "home.companycard.trainees" | translate}}: <strong>{{ company.traineesCompletedCount }}</strong>
    </div>

    <button class="accordion-header" (click)="toggleCompanyExpansion(company.id); $event.stopPropagation()">
      {{ 'common.inclusionIndex' | translate }}
      <span class="arrow" [class.expanded]="expandedCompanyId === company.id">▸</span>
    </button>

    <div
      class="accordion-content"
      [style.maxHeight]="expandedCompanyId === company.id ? '300px' : '0'"
      [style.paddingTop]="expandedCompanyId === company.id ? '0.5rem' : '0'"
      [style.paddingBottom]="expandedCompanyId === company.id ? '0.5rem' : '0'"
      [style.overflow]="expandedCompanyId === company.id ? 'visible' : 'hidden'"
      [style.transition]="'max-height 0.3s ease-out, padding 0.3s ease-out'"
    >
 <ng-container *ngIf="expandedCompanyId === company.id">
  <div *ngFor="let dim of dimensionLabels" class="dimension-row">
    <label>
      <span
        class="color-dot"
        [ngStyle]="{'background-color': getColor(company.dimensionScores?.[dim.key])}">
      </span>
      {{ dim.label }}
    </label>
    <div class="rating-value">
      {{ getDimensionScore(company, dim.key) }}
    </div>
  </div>
</ng-container>






    </div>
    </div>
  </div>
  }
</div>

</div>

</main>
<app-footer></app-footer>
